<template>
    <v-row>
        <v-col cols="12">
            <v-tabs v-model="activeTab" class="tab_budget_form_mobile" mandatory>
                <!-- // ** onglets -->
                <v-tab
                    ripple
                    v-if="showEditCompany"
                    value="EditCompany"
                    data-cy="companiesTable-editCompany-tab"
                    >Edition Société</v-tab
                >
                <v-tab
                    ripple
                    v-if="showCompanyContacts"
                    value="CompanyContacts"
                    data-cy="companiesTable-companiesContacts-tab"
                    >Contacts Société</v-tab
                >
                <v-tab
                    ripple
                    v-if="showCompanyIBANS"
                    value="CompanyIBANS"
                    data-cy="companiesTable-companyIBANS-tab"
                    >IBANS</v-tab
                >
                <v-tab
                    ripple
                    v-if="showCompanyProducts"
                    value="CompanyProducts"
                    data-cy="companiesTable-CompanyProducts-tab"
                    >Produits</v-tab
                >
                <v-tab
                    ripple
                    v-if="showTagRules"
                    key="TagRules"
                    value="TagRules"
                    href="#TagRules"
                    data-cy="companiesTable-TagRules-tab"
                    >Etiquettes</v-tab
                >
            </v-tabs>
            <v-tabs-window v-model="activeTab">
                <v-tabs-window-item
                    v-if="showEditCompany && activeTab === 'EditCompany'"
                    value="EditCompany"
                >
                    <EditThirdPartyCompany
                        :actions="actions"
                        :inThirdPartyCompanyId="thirdPartyCompanyId"
                        :parentCompanyId="companyId"
                        ref="editCompanyIndex"
                        @upsert="emitUpsert($event)"
                    />
                </v-tabs-window-item>

                <!-- contacts company -->
                <v-tabs-window-item
                    v-if="showCompanyContacts && activeTab === 'CompanyContacts'"
                    value="CompanyContacts"
                >
                    <ThirdCompanyUsersEdition
                        :onlyToCreate="false"
                        :companyId="companyId"
                        :inThirdPartyCompanyId="thirdPartyCompanyId"
                        :showEditUsers="true"
                        :actions="actions"
                        @create-user="emitCreateUser($event)"
                        @emit-upsert="refreshApollo($event)"
                        @step="emitStepFromComponent($event)"
                        @edit-mode="emitEditMode()"
                        ref="thirdCompanyUsersIndex"
                    >
                    </ThirdCompanyUsersEdition>
                </v-tabs-window-item>

                <!-- ibans company -->
                <v-tabs-window-item
                    v-if="showCompanyIBANS && activeTab === 'CompanyIBANS'"
                    value="CompanyIBANS"
                >
                    <ThirdCompanyIbansEdition
                        :companyId="companyId"
                        :inThirdPartyCompanyId="thirdPartyCompanyId"
                        :thirdPartyCompanyType="thirdPartyCompanyType"
                        :showEditUsers="true"
                        :actions="actions"
                        @iban-rules="emitCreateIban($event)"
                        @emit-upsert="refreshApollo($event)"
                        @step="emitStepFromComponent($event)"
                        @edit-mode="emitEditMode()"
                        ref="thirdCompanyIbansIndex"
                    >
                    </ThirdCompanyIbansEdition>
                </v-tabs-window-item>

                <!-- company products -->
                <v-tabs-window-item
                    v-if="showCompanyProducts && activeTab === 'CompanyProducts'"
                    value="CompanyProducts"
                >
                    <StockProductCompanyEdition
                        :companyId="companyId"
                        :inThirdPartyCompanyId="thirdPartyCompanyId"
                        :actions="actions"
                        @emit-upsert="refreshApollo($event)"
                        @step="emitStepFromComponent($event)"
                        @edit-mode="emitEditMode()"
                        ref="stockProductIndex"
                    >
                    </StockProductCompanyEdition>
                </v-tabs-window-item>

                <!-- tag rules -->
                <v-tabs-window-item
                    v-if="showTagRules && activeTab === 'TagRules'"
                    value="TagRules"
                >
                    <ThirdPartyCompanyTag
                        :companyId="companyId"
                        :actions="actions"
                        :thirdPartyCompanyId="thirdPartyCompanyId"
                    />
                </v-tabs-window-item>
            </v-tabs-window>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import EditThirdPartyCompany from "./EditThirdPartyCompany.vue";
import ThirdCompanyUsersEdition from "./ThirdCompanyUsersEdition.vue";
import ThirdCompanyIbansEdition from "./ThirdCompanyIbansEdition.vue";
import StockProductCompanyEdition from "./stock/StockProductTPCEdition.vue";
import ThirdPartyCompanyTag from "./tag/ThirdPartyCompanyTag.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        EditThirdPartyCompany,
        ThirdCompanyUsersEdition,
        ThirdCompanyIbansEdition,
        StockProductCompanyEdition,
        ThirdPartyCompanyTag,
    },
    emits: ["create-user", "iban-rules", "step", "edit-mode", "active-tab", "upsertDone"],
})
export class ThirdPartyCompanyEdition extends Vue {
    @Prop({ default: true }) showEditCompany!: boolean;
    @Prop({ default: false }) showCompanyContacts!: boolean;
    @Prop({ default: false }) showCompanyIBANS!: boolean;
    @Prop({ default: false }) showCompanyProducts!: boolean;
    @Prop({ default: false }) showTagRules!: boolean;
    @Prop({ default: "" }) readonly thirdPartyCompanyId: string;
    @Prop({ default: "supplier" }) readonly thirdPartyCompanyType: string;
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: null }) actions: any;

    createUser = false;

    createdData = false;

    activeTab = "EditCompany";

    // isParentCompany = false

    emitCreateUser(createUser) {
        debugger;
        this.createUser = createUser;
        this.$emit("create-user", this.createUser);
    }

    // emitParentCompany(isParentCompany){
    //     this.isParentCompany = isParentCompany
    //     this.$emit('is-parent-company', this.isParentCompany)
    // }

    emitCreateIban(createdData) {
        this.createdData = createdData;
        this.$emit("iban-rules", this.createdData);
    }

    emitStepFromComponent(stepFromChild) {
        this.$emit("step", stepFromChild);
    }

    emitEditMode() {
        this.$emit("edit-mode", true);
    }

    clearTextField() {
        //@ts-ignore
        this.$refs.thirdCompanyUsersIndex.clearUserTextField();
        //@ts-ignore
        this.$refs.thirdCompanyIbansIndex.clearIbanTextField();
    }

    changeStep() {
        debugger;
        if (this.activeTab === "CompanyContacts") {
            //@ts-ignore
            this.$refs.thirdCompanyUsersIndex.changeStep();
        } else if (this.activeTab === "CompanyIBANS") {
            // this.stepIban = "default"
            // this.$emit('step', this.stepIban)
            //@ts-ignore
            this.$refs.thirdCompanyIbansIndex.changeStep();
        }
    }

    async updateThirdPartyCompany() {
        if (this.activeTab === "CompanyIBANS") {
            //@ts-ignore
            await this.$refs.thirdCompanyIbansIndex.createIban();
        } else if (this.activeTab === "EditCompany") {
            //@ts-ignore
            await this.$refs.editCompanyIndex.upsertCompany();
        } else {
            if (this.activeTab === "CompanyContacts" && this.createUser) {
                //@ts-ignore
                await this.$refs.thirdCompanyUsersIndex.createClient();
            }
        }
    }

    @Watch("activeTab")
    emitActiveTabValue() {
        this.$emit("active-tab", this.activeTab);
    }

    refreshApollo(event) {
        // if(event){
        //     this.$apollo.queries.thirdPartyCompanyDatas.refetch()
        // }
    }

    emitUpsert(event) {
        this.$emit("upsertDone");
    }
}

export default toNative(ThirdPartyCompanyEdition);
</script>
